import React, { useContext, useState } from 'react';

import { GlobalContext } from '../../reducers/global';
import Modal from '../Modal';
import Cta from '../Cta';
import Graph from '../Graph';
import Toggle from '../Toggle';
import Download from '../../components/DownloadPdf';
import langs from '../../translations/langs';

const Layout = ({ children, type, url, wcd, name, leftVal, leftText, rightText, rightVal, setValue, page, downloadText }) => {
  const {
    state: {
      options: { language },
    }
  } = useContext(GlobalContext);
  const { step3, cta } = langs[language];
  const [isOpen, setIsOpen] = useState(false);

  const imageSectionStyleBlock = `
    .image-section:empty {
      background-image: url(${document.querySelector('#mth-calc-app').dataset.hero});
      height: 480px;
      background-size: contain;
    }`

  const getPage = (pageSlug) => {
    switch (pageSlug) {
      case "results":
        return (
          <div className="graph-desktop">
            <Toggle
              name={name}
              leftVal={leftVal}
              leftText={leftText}
              rightVal={rightVal}
              rightText={rightText}
              setValue={setValue}
            />
            <Graph type={type} url={url} wcd={wcd} />
            {(language === 'fr_BE' || language === 'nl_BE') && <a className="calculator-external-link" href="https://www.opgroeien.be " target="_blank">(http://www.opgroeien.be )</a>}
            <Download id="calculator-download-pdf" text={downloadText} wcd={wcd} />
          </div>
        );
      case "returningResults":
        return (
          <div className="graph-desktop">
            <Toggle
              name={name}
              leftVal={leftVal}
              leftText={leftText}
              rightVal={rightVal}
              rightText={rightText}
              setValue={setValue}
            />
            <Graph type={type} url={url} wcd={wcd} />
            <Download id="calculator-download-pdf" text={downloadText} wcd={wcd} />
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <>
      {/* eslint-disable react/no-danger */}
      <style dangerouslySetInnerHTML={{ __html: imageSectionStyleBlock }} />
      {/* eslint-enable react/no-danger */}
      <div className="mth-calc-layout">
        <div className="content-section">
          <div className="content-col">{children}</div>
        </div>
        <div className="image-section">
          {getPage(page)}
        </div>
      </div>
      {(cta.resultTitle || cta.firstTitle) && (
        <Cta
        title={page === 'results' ? cta.resultTitle : cta.firstTitle}
        description={page === 'results' ? cta.resultDescription : cta.firstDescription}
        imageUrl={page === 'results' ? 'https://u.morethanheight.com/uploads/2023/03/cta-11.png' : 'https://u.morethanheight.com/uploads/2023/03/cta-9.png'}
        bgClass={page === 'results' ? 'shape-bg-grey shape-bg-grey-top' : 'shape-bg-warning shape-bg-warning-top'}
        btnText={page === 'results' ? cta.resultBtnText : cta.firstBtnText}
        btnOnclick={page === 'results' ? () => window.location.href = cta.btnLink : () => setIsOpen(!isOpen)}>
        {page === 'results' ? <></> : (<Modal isOpen={isOpen} setIsOpen={() => setIsOpen(!isOpen)} modalText={step3.heightModal} />)}
      </Cta>
      )}
      
    </>
  );
};

export default Layout;
